import { assert } from '../../../utils'

import { type BufferType, ConnectwareError, ConnectwareErrorType, type Explorer, selectExplorerLatestTopicValues } from '../../../domain'

import { ExplorerUsecase } from './Explorer'

export class ExplorerTopicsFormattingUsecase extends ExplorerUsecase {
    selectLatestValueType (topic: keyof Explorer['latestValues'], selectedType: BufferType): void {
        const { [topic]: latestValue, ...latestValues } = selectExplorerLatestTopicValues(this.getState())

        assert(latestValue, new ConnectwareError(ConnectwareErrorType.STATE, 'Latest value not found', { topic }))

        assert(
            latestValue.possibleTypes.includes(selectedType),
            new ConnectwareError(ConnectwareErrorType.STATE, 'Selected type not allowed', {
                topic,
                selectedType,
                allowedValues: latestValue.possibleTypes,
            })
        )

        if (selectedType !== latestValue.selectedType) {
            this.setExplorer({ latestValues: { ...latestValues, [topic]: { ...latestValue, selectedType } } })
        }
    }
}
